/* eslint-disable no-unused-vars */
import Vue from 'vue'
import Vuex from 'vuex'
import DataLayer from '@/store/MiscDataLayer'
import { categories } from '@/store/Categories.js'
import injectGeoInfo from '@/store/InjectGeoInfo.js'
import _uniqBy from 'lodash/uniqBy'
import VueGeolocation from 'vue-browser-geolocation'
import _groupBy from 'lodash/groupBy'

Vue.use(Vuex)

/* eslint-disable no-unused-vars */

export default new Vuex.Store({
  state: {
    allSpecies: [],
    featuredSpecies: [],
    allSpecEnvGroupByEnv: [],
    allSpecEnvGroupBySpec: [],
    facts: [],
    generalArea: 'all',
    speciesInLan: [],
    categories,
    subCategories: [],
    navigationDrawer: false,
    ready: false,
    findingMyLocationUI: {
      display: false,
      text: 'Försöker hitta din position',
      loading: false
    }
  },
  getters: {
    areaName: state => state.generalArea,
    getClientMode: state => {
      const mode = localStorage.clientMode ? localStorage.clientMode : 'normal'
      return mode
    },
    getAllSpecies: state => {
      switch (state.generalArea) {
        case 'all':
          return state.allSpecies
        case 'ost':
          return state.allSpecies.filter(s => s.ost === true)
        case 'vast':
          return state.allSpecies.filter(s => s.vast === true)
        case 'ab':
          return state.allSpecies.filter(s => s.areas.includes('ab'))
        case 'c':
          return state.allSpecies.filter(s => s.areas.includes('c'))
        case 'd':
          return state.allSpecies.filter(s => s.areas.includes('d'))
        case 'e':
          return state.allSpecies.filter(s => s.areas.includes('e'))
        case 'h':
          return state.allSpecies.filter(s => s.areas.includes('h'))
        case 'i':
          return state.allSpecies.filter(s => s.areas.includes('i'))
        case 'm':
          return state.allSpecies.filter(s => s.areas.includes('m'))
        case 'k':
          return state.allSpecies.filter(s => s.areas.includes('k'))
        case 'n':
          return state.allSpecies.filter(s => s.areas.includes('n'))
        case 'o':
          return state.allSpecies.filter(s => s.areas.includes('o'))
        case 'x':
          return state.allSpecies.filter(s => s.areas.includes('x'))
        case 'y':
          return state.allSpecies.filter(s => s.areas.includes('y'))
        case 'ac':
          return state.allSpecies.filter(s => s.areas.includes('ac'))
        case 'bd':
          return state.allSpecies.filter(s => s.areas.includes('bd'))
        default:
          return state.allSpecies
      }
    },
    getFeaturedSpecies: state => {
      let featuredSpecies
      if (
        state.generalArea === 'all' ||
        state.generalArea === 'ost' ||
        state.generalArea === 'vast'
      ) {
        featuredSpecies = state.featuredSpecies.filter(
          spec => spec.geo === state.generalArea
        )
      } else {
        featuredSpecies = state.featuredSpecies.filter(s =>
          s.areas.includes(state.generalArea)
        )
      }
      return featuredSpecies
    },
    // Get sub categories by main category url
    getSubCategories: state => catUrl => {
      return state.subCategories.filter(
        subCat => subCat.category_url.toLowerCase() === catUrl.toLowerCase()
      )
    },
    getSpeciesByCategory: state => catUrl => {
      {
        return state.subCategories.filter(
          subCat => subCat.category_url === catUrl
        )
      }
    }
  },
  mutations: {
    SET_ALL_SPECIES(state, species) {
      state.allSpecies = species.sort((a, b) =>
        a.name_sve.localeCompare(b.name_sve, 'sv', { sensitivity: 'case' })
      )
    },
    SET_FEATURED_SPECIES(state, species) {
      state.featuredSpecies = species.sort((a, b) =>
        a.name_sve.localeCompare(b.name_sve, 'sv', { sensitivity: 'case' })
      )
    },
    SET_SUB_CATEGORIES(state, subCategories) {
      state.subCategories = _uniqBy(subCategories, 'sub_category')
    },
    SET_FACTS(state, facts) {
      state.facts = facts
    },
    SET_READY_STATE(state, loadingStatus) {
      state.ready = loadingStatus
    },
    SET_GENERAL_AREA(state, area) {
      state.generalArea = area
    },
    SET_NAVIGATIONDRAWER_VISIBILITY(state, boolVisible) {
      state.navigationDrawer = boolVisible
    },
    SET_SPECIES_EXIST_GEO(state, data) {},
    FINDING_MY_LOCATION_UI(state, objData) {
      state.findingMyLocationUI = objData
    },
    SET_SPEC_ENV_BY_ENV(state, data) {
      let allSpecEnvGroupByEnv = _groupBy(data, 'env_id')
      // Loops through all ENVs and creates flat arrays
      for (let i = 1; i <= 5; i++) {
        allSpecEnvGroupByEnv[i] = allSpecEnvGroupByEnv[i].map(row => {
          return row.spec_id
        })
      }
      state.allSpecEnvGroupByEnv = allSpecEnvGroupByEnv
    },
    SET_SPEC_ENV_BY_SPEC(state, data) {
      let allSpecEnvGroupBySpec = _groupBy(data, 'spec_id')
      // Loops through all Species and creates flat arrays
      for (const specId in allSpecEnvGroupBySpec) {
        allSpecEnvGroupBySpec[specId] = allSpecEnvGroupBySpec[specId].map(
          row => {
            return row.env_id
          }
        )
      }
      state.allSpecEnvGroupBySpec = allSpecEnvGroupBySpec
    }
  },
  actions: {
    setReadyState({ commit }, readyState) {
      commit('SET_READY_STATE', readyState)
    },
    setGeoLocation({ commit }) {
      commit('FINDING_MY_LOCATION_UI', {
        display: true,
        text: 'Försöker hitta din position',
        loading: true
      })
      return VueGeolocation.getLocation()
        .then(coordinates => coordinates)
        .then(coordinates =>
          DataLayer.InWhatLan(coordinates.lat, coordinates.lng)
        )
        .then(res => {
          const lan = res[0].Name
          const init = res[0].init
          // commit('SET_GENERAL_AREA', res[0].init)
          commit('FINDING_MY_LOCATION_UI', {
            display: true,
            text: 'Du befinner dig i ' + lan,
            loading: false
          })
          return init
        })

        .catch(e =>
          commit('FINDING_MY_LOCATION_UI', {
            display: true,
            text: 'Vi kunde tyvärr inte hitta din position.',
            loading: false
          })
        )
    },
    setGeneralArea({ commit }, area) {
      commit('SET_GENERAL_AREA', area)
    },
    setNavigationdrawerVisibility({ commit }, boolVisible) {
      commit('SET_NAVIGATIONDRAWER_VISIBILITY', boolVisible)
    },
    getAllSpieces({ commit }) {
      return new Promise((resolve, reject) => {
        DataLayer.getAllSpieces()
          .then(res => {
            injectGeoInfo(res.data).then(allSpecies => {
              commit('SET_ALL_SPECIES', allSpecies)
              resolve()
            })
          })
          //TODO: needs better error-handling
          .catch(e => {
            console.log(e)
            reject()
          })
      })
    },
    getFacts({ commit }) {
      return new Promise((resolve, reject) => {
        DataLayer.GetFacts()
          .then(res => {
            commit('SET_FACTS', res.data)
            resolve()
          })
          //TODO: needs better error-handling
          .catch(e => {
            console.log(e)
            reject()
          })
      })
    },
    getFeaturedSpecies({ commit }) {
      return new Promise((resolve, reject) => {
        DataLayer.GetFeaturedSpecies()
          .then(res => {
            injectGeoInfo(res.data).then(featuredSpecies => {
              commit('SET_FEATURED_SPECIES', featuredSpecies)
              resolve()
            })
          })
          //TODO: needs better error-handling
          .catch(e => {
            console.log(e)
            reject()
          })
      })
    },
    getSubCategories({ commit }) {
      return new Promise((resolve, reject) => {
        DataLayer.GetSubCategories()
          .then(res => {
            commit('SET_SUB_CATEGORIES', res.data)
            resolve()
          })
          //TODO: needs better error-handling
          .catch(e => {
            console.log(e)
            reject()
          })
      })
    },
    GetSpecEnv({ commit }) {
      return new Promise((resolve, reject) => {
        DataLayer.GetSpecEnv()
          .then(res => {
            commit('SET_SPEC_ENV_BY_ENV', res.data)
            commit('SET_SPEC_ENV_BY_SPEC', res.data)
            resolve()
          })
          //TODO: needs better error-handling
          .catch(e => {
            console.log(e)
            reject()
          })
      })
    },
    prefetchPage({ commit }, id) {
      return new Promise((resolve, reject) => {
        DataLayer.prefetchPage(id)
          .then(res => {
            resolve()
          })
          //TODO: needs better error-handling
          .catch(e => {
            console.log(e)
            reject()
          })
      })
    }
  },
  modules: {}
})
